// src/utils/mitt-bus.js
import mitt from 'mitt'

// 创建 mitt 实例
const mittBus = mitt()

// 导出实例（全局唯一）
export default mittBus